import type { AttentionItem } from "./api";

interface AttentionBannerProps {
  attention: AttentionItem[];
  opportunities: AttentionItem[];
}

export function AttentionBanner({ attention, opportunities }: AttentionBannerProps) {
  return (
    <>
      {attention.length > 0 && (
        <div className="cx-admin-attention">
          <div className="cx-admin-attention-title">
            {attention.length} {attention.length === 1 ? "thing needs" : "things need"} attention
          </div>
          <div className="cx-admin-attention-items">
            {attention.map((item, i) => (
              <div key={i} className="cx-admin-attention-item">
                <span className="cx-admin-attention-dot" />
                <span>{item.summary}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {opportunities.length > 0 && (
        <div className="cx-admin-opportunities">
          <span className="cx-admin-opp-label">Opportunities</span>
          {opportunities.map((opp, i) => (
            <span key={i}>
              {i > 0 && (
                <span style={{ color: "var(--color-border)", margin: "0 4px" }}>|</span>
              )}
              {opp.summary}
            </span>
          ))}
        </div>
      )}
    </>
  );
}
